module.exports = __webpack_public_path__ + "img/632.761acc6d.jpg";